<template>
    <ion-content>
        <ion-slides pager="true" v-if="deal.images && deal.images.length > 0">
            <ion-slide v-for="image of deal.images" :key="deal.images.indexOf(image)">
                <img :src="image"  class="abc"/>
            </ion-slide>
            <!--<ion-slide>
                <img src="https://images.unsplash.com/photo-1508710985089-e985fabbb184?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80&h=750" />
            </ion-slide>
            <ion-slide>
                <img src="https://images.unsplash.com/photo-1515519158088-d2a3acf621b9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80&h=750" />
            </ion-slide>
            <ion-slide>
                <img src="https://images.unsplash.com/photo-1471960098958-2059c6681742?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80&h=750" />
            </ion-slide>
            <ion-slide>
                <img src="https://images.unsplash.com/photo-1533558493928-231014635309?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80&h=750" />
            </ion-slide>
            <ion-slide>
                <img src="https://images.unsplash.com/photo-1506501139174-099022df5260?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80&h=750" />
            </ion-slide>-->
        </ion-slides>
        <div>
            <div class="otime"><ion-icon name="time"></ion-icon>  {{deal.when}}</div>
            <h1>{{deal.title}}</h1>
            <p>San Francisco is a city in the U.S. state of California. It is famous for the Golden Gate Bridge. With a population of 744,041, San Francisco is the 13th largest city in the United States, and the 4th largest city in California behind Los Angeles, San Diego, and San Jose. It is in the northern part of California, between the Pacific Ocean and the San Francisco Bay. The urbanized San Francisco Bay Area surrounds it.</p>
            <ion-card v-for="(item, key) of deal.items" :key="key">
                <ion-card-header>
                    <div class="price" v-if="deal.cost.currency == '$' || deal.cost.currency == '£'">{{deal.cost.currency}}{{deal.cost.min}}</div>
                    <div class="price" v-else>{{deal.cost.min}} {{deal.cost.currency}}</div>
                    <ion-card-title>
                        <div class="date">
                            {{removeLeadingZero(item.flight.outbound.date.split('-')[2])}}
                            <div class="month">{{getMonthName(item.flight.outbound.date.split('-')[1])}}</div>
                        </div>
                        <div class="dots">...</div>
                        <div class="date">
                            {{removeLeadingZero(item.flight.return.date.split('-')[2])}}
                            <div class="month">{{getMonthName(item.flight.return.date.split('-')[1])}}</div>
                        </div>
                    </ion-card-title>
                </ion-card-header>

                <ion-card-content>
                    <ion-segment>
                        <ion-segment-button value="flights" checked="true">
                        <ion-label>Flights</ion-label>
                        </ion-segment-button>
                        <ion-segment-button value="hotels" v-if="deal.type == 'hotel'">
                        <ion-label>Hotels</ion-label>
                        </ion-segment-button>
                    </ion-segment>
                    <div class="flight in">{{item.flight.outbound.airports.departure}}<div class="time">7.30</div></div>
                    <div class="flight spacer"><i class="right" /><i class="right" /><i class="right" /><i class="right" /><i class="right" /><i class="right" /><i class="right" /><i class="right" /><i class="right" /><i class="right" /></div>
                    <div class="flight out">{{item.flight.outbound.airports.arrival}}<div class="time">9.00</div></div>
                    <div class="flight in">{{item.flight.return.airports.arrival}}<div class="time">10.10</div></div>
                    <div class="flight spacer"><i class="left" /><i class="left" /><i class="left" /><i class="left" /><i class="left" /><i class="left" /><i class="left" /><i class="left" /><i class="left" /><i class="left" /></div>
                    <div class="flight out">{{item.flight.return.airports.departure}}<div class="time">16.20</div></div>
                    <ion-button target="_blank" :href="item.flight.outbound.link">BOOK FLIGHT</ion-button>
                </ion-card-content>
            </ion-card>
        </div>
    </ion-content>
</template>

<script>
export default {
  name: 'DealDetail',
  props: {
    deal: Object,
  },
  methods: {
    getMonthName: function (month) {
      var months = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", 
           "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
      return months[month - 1].toUpperCase();
    },
    removeLeadingZero: function(number) {
        return parseInt(number).toString();
    }
  }
};
</script>

<style scoped>
ion-card-header {
    position: relative;
}

ion-card {
    overflow: visible;
    margin-top: 2em;
}

ion-segment {
    margin-bottom: 1.5em;
}

ion-card-header .price {
    position: absolute;
    top: -.5em;
    background-color: #f05;
    font-size: 2em;
    right: .7em;
    color: #fff;
    padding: .25em;
    font-weight: bold;
    border-radius: 3px;
    box-shadow: 0px 1px 3px #999;
}

.flight {
    font-weight: bold;
    font-size: 1.2em;
    padding: 0 1em;
}

.flight.in {
    float: left;
}

.flight.spacer {
    float: left;
}

.flight .right {
  border: solid #ccc;
  border-width: 0 3px 3px 0;
  display: inline-block;
  margin-left: .5em;
  padding: 3px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.flight .left {
  border: solid #ccc;
  border-width: 0 3px 3px 0;
  display: inline-block;
  margin-left: .5em;
  padding: 3px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.flight .time, .flight .time {
    font-size: .8em;
    font-weight: normal;
}

.flight.out {
    text-align: right;
}

.otime {
    color: #999;
    text-align: left;
    padding: 1em;
    font-size: calc(.5em + 1vw);
}

.date {
    font-size: 2em;
    font-weight: bold;
    float: left;
}

.date .month {
    font-size: .4em;
    font-weight: bold;
}

.dots {
    float: left;
    padding: .5em;
    color: #999;
}

p {
    padding: 0 1em;
    text-align: justify;
    font-size: .8em;
    line-height: 1.5;
}

h1 {
    text-align: left;
    padding: 0 .5em;
    margin-top: 0;
}

.title {
    text-align: left;
    font-size: calc(2em + 1vw);
}

.tags {
    text-align: left;
}
</style>
